import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines multiple class value inputs into a single string of class names,
 * merging Tailwind CSS classes intelligently to avoid conflicts.
 *
 * @param inputs - A list of class values (strings, arrays, objects, etc.) to be combined.
 * @returns A single string of merged class names.
 *
 * @example
 * ```typescript
 * cn('btn', { 'btn-active': isActive }, ['extra-class']);
 * // => 'btn btn-active extra-class'
 * ```
 */
const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export { cn };
